<!--  -->
<template>
    <div class="dispatch-no-list" ref="listRefs">
        <div
            class="title"
            :style="{
                'justify-content': titleFlag ? 'space-between' : 'center',
            }"
        >
            <span v-if="titleFlag">发车单</span>
            <span
                class="el-icon-s-fold"
                v-if="span === 4"
                @click="expandAndCollapse(1)"
            ></span>
            <span
                class="el-icon-s-unfold"
                v-else
                @click="expandAndCollapse(4)"
            ></span>
            <div class="search-icon" v-if="titleFlag">
                <span
                    class="el-icon-upload2"
                    v-if="!seacrchIconFlag"
                    @click="seacrchIconFlag = true"
                ></span>
                <span
                    class="el-icon-download"
                    v-else
                    @click="seacrchIconFlag = false"
                ></span>
            </div>
        </div>
        <div class="main-search" v-show="titleFlag">
            <el-form :model="form" label-width="60px" v-if="!seacrchIconFlag">
                <el-form-item label="发车单">
                    <el-input
                        v-model.trim="form.dispatchNo"
                        placeholder="请输入发车单号"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="客户订单">
                    <el-input
                        v-model.trim="form.customerOrderNo"
                        placeholder="请输入客户订单号"
                        clearable
                    />
                </el-form-item>
                <!-- <el-form-item label="供应商" prop="handlingCarrierName">
                    <advance-dialog
                        v-model="form.carrierName"
                        :mValue="form.carrierName"
                        :params="carrierConfig"
                        @getAdvanceValue="getAdvance">
                    </advance-dialog>
                </el-form-item> -->
                <el-form-item label="服务平台" prop="siteName">
                    <advance-dialog
                        v-model="form.siteName"
                        :mValue="form.siteName"
                        :params="siteConfig"
                        @getAdvanceValue="getAdvance">
                    </advance-dialog>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" @click="handleSearch">
                        查询
                    </el-button>
                    <el-button size="mini" @click="handleReset()">
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div :class="[seacrchIconFlag || !titleFlag ? 'main-list-fold' : 'main-list-unfold']">
            <div
                v-if="titleFlag"
                class="main-list"
            >
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item
                        :name="index"
                        v-for="(item, index) in carrierList"
                        :key="index"
                    >
                        <template slot="title">
                            <span
                                :title="item.carrierName"
                                class="main-list-title-name"
                            >
                                {{ item.carrierName }}
                            </span>
                            <span>({{ item.count }})</span>
                        </template>
                        <div v-loading="item.loading">
                            <div
                                @click="handleItem(k)"
                                v-for="(k, v) in item.dispatchs"
                                :key="v"
                                :class="[
                                    'car-list', 'bigData-btn-query',
                                    {
                                        'car-item-active':
                                            currentItem.dispatchNo === k.dispatchNo && !currentItem.deviceNo
                                    },
                                ]"
                            >
                                <div class="dispatchs-top">
                                    <span>{{ k.dispatchNo }}</span>
                                    <span>{{ k.vehicleCard }}</span>
                                </div>
                                <div class="dispatchs-address">
                                    出发:{{ k.senderDetailAddr }}
                                </div>
                                <div class="dispatchs-address">
                                    目的:{{ k.receiverDetailAddr }}
                                </div>
                                <div class="dispatchs-device" v-if="Array.isArray(k.deviceList) && k.deviceList.length">
                                    <div v-for="(deviceItem, deviceIndex) in k.deviceList" :key="deviceIndex">
                                        <div
                                            @click.stop="handleChangeDevice(k, deviceItem)"
                                            :class="{'device-item-active': k.deviceNo === deviceItem}"
                                            >设备{{ deviceIndex + 1 }}: {{ deviceItem }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <!-- 分页 -->
        <!-- <div class="waybillMapMonitorPagination" v-show="titleFlag">
            <div v-if="carrierList.length > 0">
                <el-pagination
                    small
                    layout="prev, pager, next"
                    :total="pageTotal"
                    :current-page.sync="query.pageNo"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
                <div class="pageFooter">
                    <div class="pagaTotal">共 {{ pageTotal }} 条</div>
                    <div class="toTargetPage">
                        前往：<el-input
                            v-model="inputPageNo"
                            size="mini"
                            @input="handleChangePageNo"
                            @keyup.enter.native="
                                handleCurrentChange(Number(inputPageNo))
                                "
                        />页
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import advanceDialog from '@/components/lots/otpAdvance';
import { carrierConfig, siteConfig } from './config.js';
import { getMonitorCarrier, getMonitorDispatch } from '../../../../api/performanceDispatchInRoadMonitor.js';
export default {
    components: { advanceDialog },
    watch: {
        // seacrchIconFlag (val) {
        //     if (val) {
        //         this.mainListHeight = this.$refs.listRefs.offsetHeight - 71;
        //     } else {
        //         this.mainListHeight = this.$refs.listRefs.offsetHeight - 230;
        //     }
        // }
    },
    data () {
        return {
            siteConfig,
            carrierConfig,
            loading: true,
            selectLoading: true,
            options: [],
            titleFlag: true,
            seacrchIconFlag: false,
            span: 4,
            mainListHeight: 0,
            inputPageNo: 1,
            pageTotal: 0, // 分页总数据
            query: { pageNo: 1, pageSize: 10 }, // 分页
            form: {
                dispatchNo: '',
                customerOrderNo: '',
                siteName: '',
                siteCode: ''
                // carrierName: '',
                // carrierCode: ''
            },
            activeNames: [],
            carrierList: [],
            dispatchs: [],
            currentItem: {}
        };
    },
    computed: {
        ...mapGetters(['user', 'menus']),
        ...mapState({
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier,
            user: state => state.user
        })
    },
    mounted () {
        // this.$nextTick(() => {
        //     this.mainListHeight = this.$refs.listRefs.offsetHeight - 230;
        // });
    },
    methods: {
        /**
        * @description 高级选择框回调
        * @param {Object} data 选中的数据
        */
        getAdvance (data) {
            Object.keys(data).forEach(k => {
                this.form[k] = data[k] || '';
            });
        },
        handleChangePageNo () {
            this.inputPageNo = this.inputPageNo.replace(/\D/g, '');
        },
        // 切换当前分页
        handleCurrentChange (pageNo) {
            this.query.pageNo = pageNo;
            this.inputPageNo = pageNo;
            this.getList(this.form.dispatchNo);
        },
        /**
         * @description 获取承运商信息列表
         * @param dispatchNo 发车单编号
        */
        getList (dispatchNo = '') {
            const params = {
                dispatchNo: dispatchNo || '',
                customerOrderNo: this.form.customerOrderNo || '',
                siteCode: this.form.siteCode || '',
                carrierCode: this.supplier.supplierCode // 供应商编码-LSP
            };
            return getMonitorCarrier(params).then((res) => {
                if (res && +res.code === 0) {
                    res.data.forEach((e) => {
                        e.loading = false;
                    });
                    this.carrierList = res.data;
                    if (!this.carrierList.length) {
                        this.$emit('setSelectDispatchNoData', {});
                        this.$message.warning('暂无在途轨迹');
                    }
                }
            });
        },
        /**
         * @description 获取发车单信息列表
         * @param carrierCode 供应商code
         * @param index 所选承运商索引
        */
        getDispatchList (carrierCode, siteCode, index) {
            this.carrierList[index].loading = true;
            return getMonitorDispatch({ carrierCode, siteCode, dispatchNo: this.form.dispatchNo, customerOrderNo: this.form.customerOrderNo }).then((res) => {
                if (res && +res.code === 0) {
                    this.carrierList[index].dispatchs = res.data;
                } else {
                    for (let i = 0; i < this.activeNames.length; i++) {
                        if (this.activeNames[i] === index) {
                            this.activeNames.splice(i, 1);
                        }
                    }
                }
            }).finally(() => {
                setTimeout(() => {
                    this.carrierList[index].loading = false;
                }, 500);
            });
        },
        /**
         * @description 折叠面板展开和收起
         * @param val 所选折叠面板参数
        */
        handleChange (val) {
            if (val.length) {
                val.forEach((e) => {
                    if (!this.carrierList[e].dispatchs) {
                        this.getDispatchList(this.carrierList[e].carrierCode, this.form.siteCode, e);
                    }
                });
            }
        },
        /**
         * @description 收起和展开发车单列表
         * @param num col中span参数
        */
        expandAndCollapse (num) {
            this.span = num;
            if (num === 1) {
                this.titleFlag = !this.titleFlag;
            } else {
                setTimeout(() => {
                    this.titleFlag = !this.titleFlag;
                }, 300);
            }
            this.$emit('getColSpan', num);
        },
        /**
         * @description 查詢
        */
        handleSearch () {
            this.currentItem = {};
            this.activeNames = [];
            this.getList(this.form.dispatchNo);
        },
        /**
         * @description 重置
        */
        async handleReset (data = '') {
            this.currentItem = {};
            this.activeNames = [];
            this.inputPageNo = 1;
            this.form.siteName = '';
            this.form.siteCode = '';
            this.form.dispatchNo = '';
            this.form.customerOrderNo = '';
            // this.form.carrierCode = '';
            // this.form.carrierName = '';
            await this.getList(data);
        },
        /**
         * @description 列表所选数据
         * @param {Object} val 所选参数
        */
        handleItem (val) {
            if (val.flag) {
                val.flag = false;
            } else {
                val.flag = true;
            }
            val.deviceNo = '';
            this.currentItem = val;
            this.$emit('setSelectDispatchNoData', val);
        },
        /**
         * @description 查询设备号的轨迹信息
         * @param {Object} val 所选参数
        */
        handleChangeDevice (currentItem, deviceNo) {
            this.currentItem = currentItem;
            this.$set(this.currentItem, 'deviceNo', deviceNo);
            this.$emit('setSelectDispatchNoData', this.currentItem, deviceNo);
        },
        /**
         * @description 查看发车单轨迹
         * @param {Object} data 发车单号
        */
        async search (data) {
            this.form.dispatchNo = data;
            await this.getList(data);
            // 设置列表高度
            this.mainListHeight = this.$refs.listRefs.offsetHeight - 230;
            if (this.carrierList.length) {
                // 选中并打开折叠面板
                this.activeNames.push(0);
                await this.getDispatchList(this.carrierList[0].carrierCode, this.form.siteCode, 0);
                // 选中列表数据
                this.handleItem(this.carrierList[0].dispatchs[0]);
            }
        }
    }
};
</script>
<style lang='less' scoped>
.dispatch-no-list {
    height: 100%;
}
.title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #22293a;
    font-size: 15px;
    font-weight: bold;
    padding: 0 8px;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #cfd3dc;
    background-color: #fafafa;
    .el-icon-s-fold,
    .el-icon-s-unfold {
        cursor: pointer;
        font-size: 24px;
    }

    .search-icon {
        cursor: pointer;
        position: absolute;
        left: 46%;
        bottom: -30px;
        color: #8a8a8a;
        font-size: 20px;
    }
}
.main-search {
    padding: 0 10px;
    margin-top: 20px;
    margin-bottom: 10px;
    /deep/ .el-form-item {
        margin-bottom: 0;
        -moz-user-select: none; /* Firefox私有属性 */
        -webkit-user-select: none; /* WebKit内核私有属性 */
        -ms-user-select: none; /* IE私有属性(IE10及以后) */
        -khtml-user-select: none; /* KHTML内核私有属性 */
        -o-user-select: none; /* Opera私有属性 */
        user-select: none; /* CSS3属性 */
    }
    /deep/.el-form-item:last-child {
        .el-form-item__content {
            display: flex;
            align-items: flex-end;
            justify-content: end;
        }
    }
    /deep/.el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}
.main-list-fold {
    overflow-y: auto;
    height: calc(~'100vh - 80px');
}
.main-list-unfold {
    overflow-y: auto;
    height: calc(~'100vh - 222px');
}
.main-list {
    // min-height: calc(~'100vh - 250px');
    .main-list-title-name {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /deep/.el-collapse {
        .el-collapse-item__header {
            height: 39px;
            padding: 0 5px;
        }
        .el-collapse-item__content {
            cursor: pointer;
            border-top: 1px solid #ebeef5;
            padding-bottom: 10px;
            .car-list {
                padding: 10px;
                border-bottom: 1px solid #ebeef5;
                .dispatchs-top {
                    display: flex;
                    justify-content: space-between;
                    span:first-child {
                        color: #419fff;
                    }
                }
            }
            .car-item-active {
                color: #fff;
                background: #409eff;
                .dispatchs-top {
                    span:first-child {
                        color: #fff;
                    }
                }
            }
            .device-item-active {
                color: #409eff;
            }
        }
    }
    /deep/ .el-loading-parent--relative {
        height: 50px;
        transition: height 5s;
    }
}

.waybillMapMonitorPagination {
    margin-top: 10px;
    height: 60px;
    .el-pagination {
        text-align: center;
        overflow: hidden;
        padding: 0;
        margin-bottom: 8px;
    }
    .pageFooter {
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        .pagaTotal {
            border: 1px solid #ddd;
            text-align: center;
            color: #666;
            padding: 3px 8px;
            margin-right: 15px;
            border-radius: 4px;
        }
        .toTargetPage {
            display: flex;
            align-items: center;
            .el-input {
                margin: 0 5px;
                width: 60px;
                .el-input__inner {
                    border-radius: 20px;
                }
            }
        }
    }
}
</style>
